import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

const CustomDialog = (props) => {
  const classes = useStyles()
  const { handleClose, ...remainingProps } = props
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...remainingProps}
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      {props.handleClose && (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={props.handleClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          children={props.content}
        />
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  )
}

export default CustomDialog
